import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import GenericButton from "@/components/buttons/GenericButton.vue";
import { GenericButtonVariantEnum } from "@/types/button";
import { useRouter } from "vue-router";

interface Props {
  variant: GenericButtonVariantEnum;
  text?: string;
  to?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkButton',
  props: {
    variant: { default: GenericButtonVariantEnum.Primary },
    text: { default: "" },
    to: { default: "" }
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();

const handleRedirect = () => {
  router.push(props.to);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GenericButton, {
    variant: _ctx.variant,
    text: _ctx.text,
    "on-click": handleRedirect
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["variant", "text"]))
}
}

})